var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlIntercityExpressway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181.769 132.556",
    height: 501,
    width: 687,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.507 -24.923)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 23.813,
    rx: 23.813,
    y: 25.056,
    x: 26.639,
    height: 132.292,
    width: 181.504,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.265
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 26.639 25.056)",
    d: "M 90,30 C 56.760001,30 30,56.760001 30,90 v 320 c 0,33.24 26.760001,60 60,60 h 506 c 33.24,0 60,-26.76 60,-60 V 90 C 656,56.760001 629.24,30 596,30 Z M 343,67 588,97 618,250 588,403 343,433 96,403 68,250 96,97 Z",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlIntercityExpressway);
export default __webpack_public_path__ + "static/media/il-intercity-expressway.0a8c8bf72b69e5dca3a83efd10354784.svg";
export { ForwardRef as ReactComponent };